module.exports = __webpack_public_path__ + "static/media/logo.d62054fa.png";